const coursesWithOverridenCollaboratorsText = [
  'ffe1600d-64cd-413c-8c2e-cde624aba2ed', // Food for Thought: The Relationship Between Food, Gut and Brain
  'c5b34c16-2d55-4179-b8f4-1508d56a3ce0', // The Human Microbiome
];

export default coursesWithOverridenCollaboratorsText;
